let resultCnt = 0;
let hasSuccess = true;
import util from "@/mixins/util";

export default {
    methods: {
        runApiUploadFiles(fileInfo, key) {
            return new Promise(resolve => {
                this.uploadFiles(fileInfo, 0, key, resolve)
            })
        },
        uploadFiles(fileInfo, index, key, resolve) {
            if(index < fileInfo.length) {
                let fileName = fileInfo[index].fileName
                let fileType = fileInfo[index].fileType
                let checkFile = !util.isEmpty(this[fileName]) && this[fileName].filter(file => file.hasOwnProperty('raw')).length > 0;
                if(checkFile) {
                    this.setApiUploadFile(this[fileName], fileType, key).then(res => {
                        this.uploadFiles(fileInfo, index + 1, key, resolve)
                    })
                }else{
                    this.uploadFiles(fileInfo, index + 1, key, resolve)
                }
            }else{
                resolve(true)
            }
        },
        setApiUploadFile(files, type, id) {
            return new Promise(resolve => {
                if(files.length === 0) {
                    resolve(true)
                }else{
                    resultCnt = 0;
                    this.uploadApiFile(files, type, id, resolve, 0);
                }
            })
        },
        uploadApiFile(files, type, id, resolve, fileIndex = 0) {
            hasSuccess = true;
            if (files[fileIndex].hasOwnProperty('raw')) {

                let file = files[fileIndex]
                let formData = new FormData();
                formData.append('files', file.raw);
                formData.append('a_container_type', type);
                formData.append('a_container_id', id);
                if (file.hasOwnProperty('a_idx')) {
                    formData.append('a_idx', file.a_idx);
                }
                if (file.hasOwnProperty('a_seq')) {
                    formData.append('a_seq', file.a_seq);
                }
                console.log(file, type, id)
                try {
                    this.$api.$file.updateFile(formData).then(res => res.Data.Result).then(res => {
                        if (res.Info.Type != 1) {
                            hasSuccess = false;
                        }
                        resultCnt = resultCnt + 1;
                        if (resultCnt >= files.length || hasSuccess === false) {
                            resolve(hasSuccess);
                            // this.initFileData();
                        } else {
                            this.uploadApiFile(files, type, id, resolve, fileIndex + 1);
                        }

                    })
                } catch (e) {
                    console.log(e)
                }
            } else {
                resultCnt = resultCnt + 1;
                if (resultCnt === files.length || hasSuccess === false) {
                    // this.initFileData();
                    resolve(hasSuccess);
                } else {
                    this.uploadApiFile(files, type, id, resolve, fileIndex + 1);
                }
            }
        },
        removeFiles(files) {
            return util.Array.each(files, (file, index, arr) => {
                if (file.hasOwnProperty('a_idx') && file.a_idx != null) {
                    let params = {
                        a_idx: file.a_idx
                    }
                    this.$api.$file.deleteFile(params).then(res => {
                        // console.log(res);
                    })
                }
            })
        },
    }
}
